import {Routes, Route, Navigate} from 'react-router-dom';
import './App.css';
import Loading from './pages/loading';
import Home from './pages/home';

function AppContent() {
  return (
    <Routes>
      <Route path="/" element={<Loading />} />
      <Route path="/home" element={<Home />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function App() {
  return (
    <AppContent />
  );
}

export default App;
